import { selectAllEntities } from '@ngneat/elf-entities';
import { createRequestDataSource } from '@ngneat/elf-requests';

import { auditsInformationStore } from './audits-information.store';

export const getAuditsInformationDataSource = createRequestDataSource({
  store: auditsInformationStore,
  data$: () => auditsInformationStore.pipe(selectAllEntities()),
  requestKey: 'getAuditsInformation',
  dataKey: 'auditsInformation',
});

